/**
 * WorkDocTextCase — Transform selected text case (UPPER/lower/Title/Sentence).
 */
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CaseSensitive } from "lucide-react";

const TRANSFORMS = [
  {
    label: "UPPERCASE",
    description: "Make all text uppercase",
    fn: (t) => t.toUpperCase(),
  },
  {
    label: "lowercase",
    description: "Make all text lowercase",
    fn: (t) => t.toLowerCase(),
  },
  {
    label: "Title Case",
    description: "Capitalize Each Word",
    fn: (t) =>
      t.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()),
  },
  {
    label: "Sentence case",
    description: "Capitalize first word only",
    fn: (t) => {
      const s = t.toLowerCase();
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
  },
  {
    label: "tOGGLE cASE",
    description: "Reverse the case of each letter",
    fn: (t) =>
      t.replace(/\w/g, (c) => (c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase())),
  },
];

export default function WorkDocTextCase({ editor }) {
  if (!editor) return null;

  const applyTransform = (transformFn) => {
    const { from, to } = editor.state.selection;
    if (from === to) return; // No selection
    const text = editor.state.doc.textBetween(from, to);
    if (!text) return;
    const transformed = transformFn(text);
    editor
      .chain()
      .focus()
      .deleteRange({ from, to })
      .insertContent(transformed)
      .run();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 px-2 text-xs gap-1 border border-gray-700 hover:bg-gray-800 text-gray-400"
        >
          <CaseSensitive className="w-4 h-4" />
          <span className="hidden sm:inline">Case</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-52 p-2 bg-gray-900 border-gray-700" side="bottom" align="start">
        <div className="space-y-0.5">
          {TRANSFORMS.map((t) => (
            <button
              key={t.label}
              className="w-full flex items-center justify-between px-3 py-2 text-sm text-gray-300 hover:bg-gray-800 rounded"
              onClick={() => applyTransform(t.fn)}
            >
              <span className="font-medium">{t.label}</span>
              <span className="text-[10px] text-gray-500">{t.description}</span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
